import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined'

import Button from '@mui/material/Button'

import useFormatMessage from '@hooks/useFormatMessage'
import ErrorLayout, { ErrorHero } from '@components/ErrorBase/ErrorBase.components'

export default function AppUpdated() {
  const formatMessage = useFormatMessage()

  return (
    <ErrorLayout
      hero={<ErrorHero icon={SystemUpdateAltOutlinedIcon} />}
      title={formatMessage('appUpdated.title')}
      subtitle={`${formatMessage('appUpdated.improvements')}\n${formatMessage('appUpdated.reloadPrompt')}`}
      primary={
        <Button size="large" variant="contained" onClick={() => window.location.reload()}>
          {formatMessage('common.reload')}
        </Button>
      }
    />
  )
}
